import { SideNav } from "components";
import { LargeButton, MainBody } from "components/core";
import { Ptag } from "components/core/fonts";
import React, { useEffect, useMemo, useState } from "react";
import { ErrorDownloadLink } from "pages/FlexSetup/styles";
import http from "services/httpService";
import { useNavigate, useLocation } from "react-router";
import routes from "components/routes";
import ErrorAnimation from "assets/lottie/error.json";
import Lottie from "react-lottie";

const ErrorFileDownload = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const super_task_id = localStorage.getItem("super_task_id");
  const [taskStatus, setTaskStatus] = useState();

  useEffect(() => {
    (async function () {
      await getTaskStatus();
    })();
  }, []);

  const getTaskStatus = async () => {
    const payload = {
      params: {
        super_task_id,
      },
    };
    const { data } = await http.get("business/get_taskset_details/", payload);
    setTaskStatus(data.task_set_data);
  };

  const showErrorDownloadLink = useMemo(() => {
    return (
      taskStatus &&
      taskStatus.async_tasks[0] &&
      taskStatus.async_tasks[0].error_file_path
    );
  }, [taskStatus]);

  const showErrorMessage = useMemo(() => {
    return (
      taskStatus && taskStatus.async_tasks[0] && taskStatus.async_tasks[0].error
    );
  }, [taskStatus]);

  const downloadErrorFile = (downloadLink) => {
    window.open(downloadLink, "_blank");
  };

  const navigateToMasterDoc = () => {
    navigate(`/${routes.UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID}`);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ErrorAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <SideNav />
      <MainBody
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Lottie
            style={{
              marginTop: "12%",
            }}
            options={defaultOptions}
            height={140}
            width={140}
            isClickToPauseDisabled
          />
          <Ptag fontSize="36px" fontWeight="700" textAlign="center">
            Error!
          </Ptag>
          <Ptag fontSize="16px" textAlign="center" marginTop="12px">
            Employee data upload failed due to data discrepancy. Please check
            the files for errors!
          </Ptag>
          {showErrorDownloadLink && (
            <div
              style={{
                display: "grid",
                placeItems: "center",
                marginTop: "24px",
              }}
            >
              <ErrorDownloadLink
                onClick={() =>
                  downloadErrorFile(taskStatus.async_tasks[0].error_file_path)
                }
              >
                Download Error File
              </ErrorDownloadLink>
            </div>
          )}
          {showErrorMessage && (
            <Ptag
              textAlign="center"
              color="#ff0e0e"
              fontSize="14px"
              marginTop="18px"
            >
              <b>Error Message :</b> {showErrorMessage}
            </Ptag>
          )}
        </div>
        <div style={{ display: "grid", placeItems: "center" }}>
          <LargeButton
            style={{ maxWidth: "800px" }}
            label="Upload Again"
            onClick={() => navigateToMasterDoc()}
          />
        </div>
      </MainBody>
    </>
  );
};

export default ErrorFileDownload;
